import { getEndpoint } from "common/backend/endpoints"
import axios from 'axios'

export const getPublicBudget = async (token,typeOfLine) => {

    axios.interceptors.request.use(
        config => {
          config.headers['Authorization'] = token
          return config
        },
        error => {
          return Promise.reject(error)
        }
    );

    try {
        const endpoint = getEndpoint('INTERACTIVE_BUDGETS')
        const endpoint_catalog = getEndpoint('INTERACTIVE_BUDGETS_CATALOG')

        const res = await axios.get(endpoint + `?typeOfLine=${typeOfLine}`)
        const res_catalog = await axios.get(endpoint_catalog + '?estadoStock=activo&presupuesto=true&validateCarLot=false')

        return {data: {...res?.data?.data, catalog: res_catalog?.data?.data}}
    } catch (err) {
        throw {code: err?.response?.status}
    }
}

export default getPublicBudget
